/***
 * 
 * 
 * Listen for change in the cart
 * 
 * 
 */

// Global Variables
const elements = {
    cartCount: document.querySelector('.js-cart-count'),
    checkoutButtonsSection: document.querySelector('.js-sh-cart-checkout'),
    cartItems: document.querySelector('[data-cart]'),
    cartEmpty: document.querySelector('.cart-empty')
}

const classes = {
    checkoutSection: 'sh-cart-checkout'
}

window.freeProduct = {
    id: 0
}

document.addEventListener('remove:free:product', e => {
    const productId = window.freeProduct.id
    if (productId !== 0) {
        const lineItem = document.querySelector(`[data-product-id="${productId}"]`);
        const lineKey = lineItem.getAttribute('data-line-item')
        
        const removeData = {
            'id': lineKey,
            'quantity': 0
        }

        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(removeData)
          })
          .then(response => {
            return response.json();
          })
          .then(data => {
            // Update Cart UI
            if (data.item_count === 0) {
                elements.cartItems.style.display = 'none';
                elements.cartEmpty.style.display = 'block'
            } else {
                lineItem.style.display = 'none';
            }

            // Update cart count
            elements.cartCount.textContent = data.item_count

            // Enable checkout buttons
            if (elements.checkoutButtonsSection.classList.contains(classes.checkoutSection)) {
                elements.checkoutButtonsSection.classList.remove(classes.checkoutSection)
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        
    }
})

